<template>
  <div class="page-mentor">
    <div class="g-wrap">
      <el-breadcrumb class="g-breadcrumb" separator="/">
        <el-breadcrumb-item to="/feature-gslc/achievement/show">成果转化</el-breadcrumb-item>
        <el-breadcrumb-item to="/feature-gslc/achievement/show/expert/list">专家</el-breadcrumb-item>
        <el-breadcrumb-item>{{ data.Name }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="g-content mentor-content">
        <div class="card">
          <div class="avatar">
            <img @error="imgError" class="avatar_img" :src="data.Photo" :alt="data.Name" />
          </div>
          <div class="right">
            <h3>{{ data.Name }}</h3>
            <p>
              <span>所属学院：{{ data.College }}</span>
              <span>学历:{{ data.Education }}</span>
              <span>职称：{{ data.ProfessionalTitle }}</span>
            </p>
          </div>
          <div class="chat"></div>
        </div>
        <div class="content-wrap">
          <column-header2 :data="{ name: '擅长领域' }"></column-header2>
          <div class="content">{{ data.Expertise }}</div>
          <column-header2 :data="{ name: '个人简介' }"></column-header2>
          <div class="content">{{ data.Introduce }}</div>
          <column-header2 :data="{ name: '专家成果' }"></column-header2>
          <ic-news :data="columnData"></ic-news>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getExpertAchievement } from "@/api/achievement";
import { getDetail } from "@/api/app";
import ColumnHeader from "_c/ColumnHeader2";
import News from "_c/News";
export default {
  data() {
    return {
      data: {},
      UserId: "",
      columnData: []
    };
  },
  created() {
    this.init();
  },
  components: {
    [ColumnHeader.name]: ColumnHeader,
    [News.name]: News
  },
  methods: {
    loadData() {
      getDetail({ name: "SchoolExpert", id: this.$route.params.id })
        .then(res => {
          this.UserId = res.Id;
          this.data = res || {};
        })
        .catch(err => console.log(err));
      getExpertAchievement(this.$route.params.id)
        .then(res => {
          console.log(res.Result.Data);
          this.columnData = (res.Result.Data || []).map(item => {
            return {
              Headline: item.Headline,
              Summary: item.Summary,
              link:
                "/feature-gslc/achievement/show-detail/achievement?id=" +
                item.Id
            };
          });
        })
        .catch(err => console.log(err));
    },
    init() {
      this.loadData();
    }
  }
};
</script>

<style lang="scss" scoped>
.page-mentor {
  background: #f6f6f9;
  padding-bottom: 40px;
  .mentor-content {
    padding: 0 0 40px 0;
    .card {
      background: url(~assets/img/feature/watermarker.png) no-repeat #5463a4 95%
        top;
      background-size: 170px auto;
      border-radius: 8px 8px 0 0;
      color: #fff;
      height: 102px;
      padding: 16px 40px;
      display: flex;
      align-items: center;
      .avatar {
        width: 104px;
        height: 104px;
        margin-right: 24px;
        .avatar_img {
          border-radius: 52px;
        }
      }
      .right {
        display: flex;
        flex-direction: column;
        justify-content: center;
        h3 {
          font-size: 20px;
          font-weight: 500;
          padding-bottom: 8px;
        }
        p {
          width: 760px;
          display: flex;
          flex-wrap: wrap;
          line-height: 22px;
          span {
            width: 33%;
          }
        }
      }
      .chat {
        .btn {
          a {
            width: 88px;
            height: 32px;
            border-radius: 20px;
            border: 1px solid $primary-color;
            color: $primary-color;
            background-color: #fff;
            display: inline-flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            margin-left: 8px;
          }
        }
      }
    }
    .content {
      font-size: 14px;
      line-height: 28px;
      color: #666;
      padding-bottom: 20px;
    }
    ::v-deep .comp-column-header {
      padding-top: 24px;
    }
    .content-wrap {
      margin: 0 168px;
    }
  }
}
</style>
